// Constants and formatting shared by the Calendar tab's screens.

export const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const TIMES = Array.from({ length: 96 }, (_, i) => {
  const h = String(Math.floor(i / 4)).padStart(2, "0");
  const m = String((i % 4) * 15).padStart(2, "0");
  return `${h}:${m}`;
}).concat(["24:00"]);
export const TIME_OPTIONS = TIMES.map((v) => ({ value: v, label: v }));
export const newServiceId = () => `s${Math.random().toString(36).slice(2, 10)}`;

export function formatLocal(iso, tz, parts = { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) {
  try {
    return new Intl.DateTimeFormat(undefined, { timeZone: tz, ...parts }).format(new Date(iso));
  } catch (_) {
    return iso;
  }
}

const rangesText = (ranges) => ranges.map((r) => `${r[0]}–${r[1]}`).join(", ");

/** "Tue–Sat, 10:00–19:00"; null when open days have different hours. */
export function hoursSummary(weekly, dayLabel) {
  const open = DAYS.filter((d) => (weekly[d] || []).length);
  if (!open.length) return "";
  const texts = new Set(open.map((d) => rangesText(weekly[d])));
  if (texts.size > 1) return null;
  const idx = open.map((d) => DAYS.indexOf(d));
  const run = idx.length >= 3 && idx.every((v, i) => i === 0 || v === idx[i - 1] + 1);
  const days = run ? `${dayLabel(open[0])}–${dayLabel(open[open.length - 1])}` : open.map(dayLabel).join(", ");
  return `${days}, ${[...texts][0]}`;
}

/** Offset of a time zone from UTC at one moment, in minutes. */
function zoneOffset(ms, tz) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", { timeZone: tz, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" })
      .formatToParts(new Date(ms))
      .map((p) => [p.type, p.value])
  );
  const asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute);
  return Math.round((asUtc - ms) / 60000);
}

/** "2026-11-02" + "13:00" in the business's time zone, as a UTC ISO string. */
export function zonedIso(dateStr, hhmm, tz) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const [h, mi] = hhmm.split(":").map(Number);
  const guess = Date.UTC(y, m - 1, d, h, mi);
  let ms = guess - zoneOffset(guess, tz) * 60000;
  ms = guess - zoneOffset(ms, tz) * 60000; // second pass settles daylight-saving edges
  return new Date(ms).toISOString();
}
